var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { AsyncRequestStatus, getAsyncRequestStatus, getCompletedAsyncWrapperObj } from "@ane/core/lib/models/IAsyncWrapper";
import detailsViewActionTypes from "./DetailsViewActionTypes.js";
import { flightActionTypes } from "./Flights.ducks.js";
import { experimentActionTypes } from "./Experiment.ducks.js";
const getDefaultState = () => {
  return { experiments: {} };
};
const getDefaultExperimentState = () => {
  return {
    experiment: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentData: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentScorecards: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentLog: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentIterations: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentOps: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentAdvanceEffect: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    experimentEditRules: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    start: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    advance: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    stop: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    hide: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    unhide: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    edit: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    iterate: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    editing: false,
    flightControl: null,
    flights: {
      status: AsyncRequestStatus.NotStarted,
      data: null
    },
    flight_assignment_status: null
  };
};
const DetailsViewReducer = (state = getDefaultState(), actionResult) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const { id, type } = actionResult;
  if (!id) {
    return state;
  }
  let experiment = !state.experiments[id] ? getDefaultExperimentState() : state.experiments[id];
  switch (type) {
    case detailsViewActionTypes.GET_EXP_DATA:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentData: __spreadProps(__spreadValues({}, experiment.experimentData), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.PARSE_EXP_DATA:
      let getExpResult = actionResult;
      let prevExpData = experiment.experimentData;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentData: getCompletedAsyncWrapperObj(
              (_a = getExpResult.payload) != null ? _a : prevExpData.data,
              getExpResult.error,
              getExpResult.errorContext
            )
          })
        })
      });
    case experimentActionTypes.LOADED_EXPERIMENT:
      let result = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experiment: getCompletedAsyncWrapperObj(result.payload, result.error)
          })
        })
      });
    case detailsViewActionTypes.GET_EXP_SCORECARDS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentScorecards: __spreadProps(__spreadValues({}, experiment.experimentScorecards), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.PARSE_EXP_SCORECARDS:
      let getScorecardsResult = actionResult;
      let prevScorecardData = experiment.experimentScorecards;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentScorecards: getCompletedAsyncWrapperObj(
              (_b = getScorecardsResult.payload) != null ? _b : prevScorecardData.data,
              getScorecardsResult.error
            )
          })
        })
      });
    case detailsViewActionTypes.GET_EXP_LOG:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentLog: __spreadProps(__spreadValues({}, experiment.experimentLog), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.PARSE_EXP_LOG:
      let getLogResult = actionResult;
      let prevExperimentLog = experiment.experimentLog;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentLog: getCompletedAsyncWrapperObj((_c = getLogResult.payload) != null ? _c : prevExperimentLog.data, getLogResult.error)
          })
        })
      });
    case detailsViewActionTypes.GET_EXP_ITERS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentIterations: __spreadProps(__spreadValues({}, experiment.experimentIterations), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.PARSE_EXP_ITERS:
      let getItrResult = actionResult;
      let prevItrResult = experiment.experimentIterations;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentIterations: getCompletedAsyncWrapperObj((_d = getItrResult.payload) != null ? _d : prevItrResult.data, getItrResult.error)
          })
        })
      });
    case detailsViewActionTypes.GET_EXP_OPS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentOps: __spreadProps(__spreadValues({}, experiment.experimentOps), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.PARSE_EXP_OPS:
      let getOpsResult = actionResult;
      let prevOpsResult = experiment.experimentOps;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentOps: getCompletedAsyncWrapperObj((_e = getOpsResult.payload) != null ? _e : prevOpsResult.data, getOpsResult.error)
          })
        })
      });
    case detailsViewActionTypes.INIT_START_EXP:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            start: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.INIT_ITERATE_EXP:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            iterate: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.FINISH_START_EXP:
      let startResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            start: getCompletedAsyncWrapperObj("Finished", startResult.error)
          })
        })
      });
    case detailsViewActionTypes.FINISH_ITERATE_EXP:
      let iterateResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            iterate: getCompletedAsyncWrapperObj("Finished", iterateResult.error)
          })
        })
      });
    case detailsViewActionTypes.GET_EXP_ADV_DIFF:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentAdvanceEffect: __spreadProps(__spreadValues({}, experiment.experimentAdvanceEffect), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.PARSE_EXP_ADV_EFFECT:
      let getAdvEffectResult = actionResult;
      let prevAdvEffectResult = experiment.experimentAdvanceEffect;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentAdvanceEffect: getCompletedAsyncWrapperObj(
              (_f = getAdvEffectResult.payload) != null ? _f : prevAdvEffectResult.data,
              getAdvEffectResult.error
            )
          })
        })
      });
    case detailsViewActionTypes.INIT_ADVANCE_EXP:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            advance: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.FINISH_ADVANCE_EXP:
      let advanceResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            advance: getCompletedAsyncWrapperObj("Finished", advanceResult.error)
          })
        })
      });
    case detailsViewActionTypes.INIT_STOP_EXP:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            stop: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.FINISH_STOP_EXP:
      let stopResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            stop: getCompletedAsyncWrapperObj("Finished", stopResult.error)
          })
        })
      });
    case detailsViewActionTypes.INIT_HIDE_EXP:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            hide: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.FINISH_HIDE_EXP:
      let hideResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentData: __spreadProps(__spreadValues({}, experiment.experimentData), {
              data: __spreadProps(__spreadValues({}, experiment.experimentData.data), {
                isHidden: !!hideResult.error ? false : true
              })
            }),
            hide: getCompletedAsyncWrapperObj("Finished", hideResult.error)
          })
        })
      });
    case detailsViewActionTypes.INIT_UNHIDE_EXP:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            unhide: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.FINISH_UNHIDE_EXP:
      let unhideResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentData: __spreadProps(__spreadValues({}, experiment.experimentData), {
              data: __spreadProps(__spreadValues({}, experiment.experimentData.data), {
                isHidden: !!unhideResult.error ? true : false
              })
            }),
            unhide: getCompletedAsyncWrapperObj("Finished", unhideResult.error)
          })
        })
      });
    case detailsViewActionTypes.LOADING_EXP_EDIT_DATA:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentEditRules: __spreadProps(__spreadValues({}, experiment.experimentEditRules), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case detailsViewActionTypes.LOADED_EXP_EDIT_DATA:
      let getEditDataResult = actionResult;
      let prevEditRules = experiment.experimentEditRules;
      let prevFlightControl = experiment.flightControl;
      return __spreadProps(__spreadValues({}, state), {
        // @ts-ignore
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            experimentEditRules: getCompletedAsyncWrapperObj(
              // @ts-ignore
              (_g = getEditDataResult.payload.editRules) != null ? _g : prevEditRules.data,
              getEditDataResult.error
            ),
            // @ts-ignore
            flightControl: getEditDataResult.error ? prevFlightControl : getEditDataResult.payload.flightControl
          })
        })
      });
    case detailsViewActionTypes.SET_EXP_EDIT_VIEW:
      let editViewResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            editing: editViewResult.isEditViewOpen
          })
        })
      });
    case detailsViewActionTypes.INIT_UPDATE_EXP_DETAILS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            edit: {
              status: AsyncRequestStatus.Pending
            }
          })
        })
      });
    case detailsViewActionTypes.FINISH_UPDATE_EXP_DETAILS:
      let updateResult = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            edit: getCompletedAsyncWrapperObj("Finished", updateResult.error),
            editing: !!updateResult.error
            // close panel if successful
          })
        })
      });
    case flightActionTypes.LOAD_FLIGHTS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            flights: {
              data: null,
              status: AsyncRequestStatus.NotStarted
            }
          })
        })
      });
    case flightActionTypes.LOADING_FLIGHTS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            flights: __spreadProps(__spreadValues({}, experiment.flights), {
              status: AsyncRequestStatus.Pending
            })
          })
        })
      });
    case flightActionTypes.LOADED_FLIGHTS:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            flights: __spreadProps(__spreadValues({}, experiment.flights), {
              status: getAsyncRequestStatus(actionResult.error),
              error: actionResult.error
            })
          })
        })
      });
    case flightActionTypes.LOADING_FLIGHT:
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            flights: __spreadProps(__spreadValues({}, experiment.flights), {
              data: __spreadProps(__spreadValues({}, experiment.flights.data), {
                [actionResult.payload.name.toLowerCase()]: {
                  Name: actionResult.payload.name,
                  Description: "",
                  IsolationGroups: ["Loading..."]
                }
              })
            })
          })
        })
      });
    case flightActionTypes.LOADED_FLIGHT:
      const actionResultCast = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        experiments: __spreadProps(__spreadValues({}, state.experiments), {
          [id]: __spreadProps(__spreadValues({}, experiment), {
            flights: __spreadProps(__spreadValues({}, experiment.flights), {
              data: __spreadProps(__spreadValues({}, experiment.flights.data), {
                [actionResultCast.name.toLowerCase()]: actionResultCast.payload.flight.data
              }),
              error: actionResult.error
            })
          })
        })
      });
    default:
      return state;
  }
};
export {
  DetailsViewReducer,
  DetailsViewReducer as default,
  getDefaultExperimentState,
  getDefaultState
};
//# sourceMappingURL=DetailsViewReducer.js.map
